module.exports = __webpack_public_path__ + "img/54.e291ae20.jpg";